// Mock data for Stockholm Elite Städ

export const companyInfo = {
  name: 'Stockholm Elite Städ',
  address: 'Storängsgatan 9, 115 44 Stockholm',
  phone: '08 84 22 33',
  email: 'office@stockholmelite.se',
  social: {
    facebook: 'https://www.facebook.com/profile.php?id=100044283490397',
    instagram: 'https://www.instagram.com/sthlmelitestad/'
  }
};

export const services = {
  sv: [
    {
      id: 'hemstadning',
      title: 'Hemstädning',
      description: 'Regelbunden städning av ditt hem. Vi tar hand om dammsugning, moppning, damning och alla ytor.',
      icon: 'Home',
      basePrice: 349,
      priceUnit: 'per tillfälle'
    },
    {
      id: 'flyttstadning',
      title: 'Flyttstädning',
      description: 'Grundlig städning vid flytt. Vi ser till att lägenheten är skinande ren för nästa boende.',
      icon: 'Truck',
      basePrice: 45,
      priceUnit: 'per m²'
    },
    {
      id: 'storstadning',
      title: 'Storstädning',
      description: 'Djuprengöring av hela hemmet. Perfekt för vårstädning eller inför särskilda tillfällen.',
      icon: 'Sparkles',
      basePrice: 55,
      priceUnit: 'per m²'
    },
    {
      id: 'fonsterputs',
      title: 'Fönsterputsning',
      description: 'Professionell rengöring av alla fönster, både in- och utsida.',
      icon: 'Square',
      basePrice: 75,
      priceUnit: 'per fönster'
    },
    {
      id: 'kontorsstadning',
      title: 'Kontorsstädning',
      description: 'Skräddarsydd städning för kontor och företag. Flexibla scheman efter era behov.',
      icon: 'Building2',
      basePrice: 35,
      priceUnit: 'per m²'
    },
    {
      id: 'trappstadning',
      title: 'Trappstädning',
      description: 'Regelbunden städning av trapphus för bostadsrättsföreningar.',
      icon: 'Stairs',
      basePrice: 299,
      priceUnit: 'per tillfälle'
    }
  ],
  en: [
    {
      id: 'hemstadning',
      title: 'Home Cleaning',
      description: 'Regular cleaning of your home. We handle vacuuming, mopping, dusting and all surfaces.',
      icon: 'Home',
      basePrice: 349,
      priceUnit: 'per session'
    },
    {
      id: 'flyttstadning',
      title: 'Move-out Cleaning',
      description: 'Thorough cleaning when moving. We ensure the apartment is spotless for the next resident.',
      icon: 'Truck',
      basePrice: 45,
      priceUnit: 'per m²'
    },
    {
      id: 'storstadning',
      title: 'Deep Cleaning',
      description: 'Deep cleaning of the entire home. Perfect for spring cleaning or special occasions.',
      icon: 'Sparkles',
      basePrice: 55,
      priceUnit: 'per m²'
    },
    {
      id: 'fonsterputs',
      title: 'Window Cleaning',
      description: 'Professional cleaning of all windows, both inside and outside.',
      icon: 'Square',
      basePrice: 75,
      priceUnit: 'per window'
    },
    {
      id: 'kontorsstadning',
      title: 'Office Cleaning',
      description: 'Customized cleaning for offices and businesses. Flexible schedules to suit your needs.',
      icon: 'Building2',
      basePrice: 35,
      priceUnit: 'per m²'
    },
    {
      id: 'trappstadning',
      title: 'Stairwell Cleaning',
      description: 'Regular cleaning of stairwells for housing associations.',
      icon: 'Stairs',
      basePrice: 299,
      priceUnit: 'per session'
    }
  ]
};

export const calculatorConfig = {
  propertyTypes: {
    sv: [
      { id: 'apartment', label: 'Lägenhet', multiplier: 1 },
      { id: 'house', label: 'Villa/Hus', multiplier: 1.2 },
      { id: 'office', label: 'Kontor', multiplier: 0.9 }
    ],
    en: [
      { id: 'apartment', label: 'Apartment', multiplier: 1 },
      { id: 'house', label: 'House/Villa', multiplier: 1.2 },
      { id: 'office', label: 'Office', multiplier: 0.9 }
    ]
  },
  cleaningTypes: {
    sv: [
      { id: 'regular', label: 'Hemstädning', pricePerSqm: 8 },
      { id: 'deep', label: 'Storstädning', pricePerSqm: 55 },
      { id: 'moving', label: 'Flyttstädning', pricePerSqm: 45 },
      { id: 'office', label: 'Kontorsstädning', pricePerSqm: 35 }
    ],
    en: [
      { id: 'regular', label: 'Regular Cleaning', pricePerSqm: 8 },
      { id: 'deep', label: 'Deep Cleaning', pricePerSqm: 55 },
      { id: 'moving', label: 'Move-out Cleaning', pricePerSqm: 45 },
      { id: 'office', label: 'Office Cleaning', pricePerSqm: 35 }
    ]
  },
  frequencies: {
    sv: [
      { id: 'once', label: 'Engångs', discount: 0 },
      { id: 'weekly', label: 'Varje vecka', discount: 20 },
      { id: 'biweekly', label: 'Varannan vecka', discount: 15 },
      { id: 'triweekly', label: 'Var 3:e vecka', discount: 10 },
      { id: 'monthly', label: 'Var 4:e vecka', discount: 5 }
    ],
    en: [
      { id: 'once', label: 'One-time', discount: 0 },
      { id: 'weekly', label: 'Weekly', discount: 20 },
      { id: 'biweekly', label: 'Every 2 weeks', discount: 15 },
      { id: 'triweekly', label: 'Every 3 weeks', discount: 10 },
      { id: 'monthly', label: 'Monthly', discount: 5 }
    ]
  },
  addons: {
    sv: [
      { id: 'windows', label: 'Fönsterputsning', price: 75, unit: 'per fönster' },
      { id: 'oven', label: 'Ugnsrengöring', price: 350, unit: 'styck' },
      { id: 'fridge', label: 'Kylskåpsrengöring', price: 250, unit: 'styck' },
      { id: 'balcony', label: 'Balkongstädning', price: 200, unit: 'styck' },
      { id: 'bedding', label: 'Byte av sängkläder', price: 50, unit: 'per säng' }
    ],
    en: [
      { id: 'windows', label: 'Window Cleaning', price: 75, unit: 'per window' },
      { id: 'oven', label: 'Oven Cleaning', price: 350, unit: 'each' },
      { id: 'fridge', label: 'Fridge Cleaning', price: 250, unit: 'each' },
      { id: 'balcony', label: 'Balcony Cleaning', price: 200, unit: 'each' },
      { id: 'bedding', label: 'Bed Linen Change', price: 50, unit: 'per bed' }
    ]
  },
  rutDeduction: 0.5, // 50% RUT avdrag
  minPrice: 500
};

export const testimonials = {
  sv: [
    {
      id: 1,
      name: 'Anita',
      location: 'Ekerö',
      text: 'Beställde en provstädning. Är jättenöjd med städningen och kan rekommendera Stockholms Elitestädning. Kommer fortsätta använda den tjänsten i framtiden.',
      rating: 5
    },
    {
      id: 2,
      name: 'Dell B',
      location: 'Stockholm',
      text: 'Bra städat. Skulle använda igen!',
      rating: 5
    },
    {
      id: 3,
      name: 'Anne',
      location: 'Spånga',
      text: 'Trevlig personal och bra resultat! Rekommenderar!',
      rating: 5
    },
    {
      id: 4,
      name: 'Kim B',
      location: 'Stockholm',
      text: 'Köpte storstädning och blev fantastiskt nöjd!!! Känns så bra att fortsätta med veckostädning!!!',
      rating: 5
    },
    {
      id: 5,
      name: 'Maraya R.',
      location: 'Stockholm',
      text: 'Städning av lägenheten varannan vecka. Vänligt bemötande. Fick vad jag förväntade.',
      rating: 5
    }
  ],
  en: [
    {
      id: 1,
      name: 'Anita',
      location: 'Ekerö',
      text: 'Ordered a trial cleaning. Very satisfied with the cleaning and can recommend Stockholm Elite Cleaning. Will continue to use their service in the future.',
      rating: 5
    },
    {
      id: 2,
      name: 'Dell B',
      location: 'Stockholm',
      text: 'Well cleaned. Would use again!',
      rating: 5
    },
    {
      id: 3,
      name: 'Anne',
      location: 'Spånga',
      text: 'Friendly staff and great results! Highly recommend!',
      rating: 5
    },
    {
      id: 4,
      name: 'Kim B',
      location: 'Stockholm',
      text: 'Ordered deep cleaning and was amazingly satisfied!!! Feels great to continue with weekly cleaning!!!',
      rating: 5
    },
    {
      id: 5,
      name: 'Maraya R.',
      location: 'Stockholm',
      text: 'Apartment cleaning every two weeks. Friendly reception. Got what I expected.',
      rating: 5
    }
  ]
};

export const faq = {
  sv: [
    {
      question: 'Vad är RUT-avdrag?',
      answer: 'RUT-avdrag är en skattereduktion för hushållstjänster. Du får tillbaka 50% av arbetskostnaden direkt på fakturan, upp till 75 000 kr per person och år.'
    },
    {
      question: 'Hur bokar jag en städning?',
      answer: 'Du kan boka via vår priskalkylator på hemsidan, ringa oss på 08 84 22 33, eller maila till office@stockholmelite.se.'
    },
    {
      question: 'Ingår städmaterial?',
      answer: 'Ja, all utrustning och alla städmaterial ingår i priset. Du behöver inte ordna något själv.'
    },
    {
      question: 'Har ni nöjd-kund-garanti?',
      answer: 'Ja! Om du inte är nöjd med städningen, kontakta oss inom 24 timmar så kommer vi ut och åtgärdar bristerna kostnadsfritt.'
    },
    {
      question: 'Hur fungerar nyckelhantering?',
      answer: 'Vi kan hämta och lämna nycklar säkert. Alla våra anställda är pålitliga och ID-kontrollerade.'
    }
  ],
  en: [
    {
      question: 'What is RUT deduction?',
      answer: 'RUT deduction is a Swedish tax reduction for household services. You get 50% of the labor cost back directly on the invoice, up to 75,000 SEK per person per year.'
    },
    {
      question: 'How do I book a cleaning?',
      answer: 'You can book via our price calculator on the website, call us at 08 84 22 33, or email office@stockholmelite.se.'
    },
    {
      question: 'Is cleaning material included?',
      answer: 'Yes, all equipment and cleaning materials are included in the price. You don\'t need to arrange anything yourself.'
    },
    {
      question: 'Do you have a satisfaction guarantee?',
      answer: 'Yes! If you\'re not satisfied with the cleaning, contact us within 24 hours and we\'ll come back and fix any issues free of charge.'
    },
    {
      question: 'How does key handling work?',
      answer: 'We can safely pick up and return keys. All our employees are reliable and ID-verified.'
    }
  ]
};

export const translations = {
  sv: {
    nav: {
      home: 'Hem',
      services: 'Tjänster',
      about: 'Om Oss',
      contact: 'Kontakt',
      faq: 'FAQ',
      admin: 'Admin'
    },
    hero: {
      title: 'Rent, Snyggt & Billigt',
      subtitle: 'Professionell städning med den personliga touchen',
      cta: 'Räkna ut pris',
      secondaryCta: 'Kontakta oss'
    },
    calculator: {
      title: 'Räkna ut pris för städning',
      propertyType: 'Typ av boende',
      size: 'Storlek (m²)',
      cleaningType: 'Typ av städning',
      frequency: 'Hur ofta?',
      addons: 'Tilläggstjänster',
      rutDeduction: 'RUT-avdrag',
      rutYes: 'Ja, tillämpa RUT',
      rutNo: 'Nej',
      basePrice: 'Grundpris',
      discount: 'Rabatt',
      afterRut: 'Efter RUT-avdrag',
      total: 'Totalt att betala',
      book: 'Boka Städning',
      pricesInclude: '* Alla priser är efter RUT och inkl. moms. All utrustning och material ingår.'
    },
    services: {
      title: 'Våra Tjänster',
      subtitle: 'Professionell städning för hem och företag',
      private: 'Privatperson',
      business: 'Företag & BRF',
      learnMore: 'Läs mer'
    },
    about: {
      title: 'Om Oss',
      subtitle: 'Din belåtenhet kommer alltid först',
      whyUs: 'Varför välja oss?',
      features: [
        { title: 'Ett tryggt val', desc: 'Vi tar hand om ditt hem på bästa sätt. Trygghet, kvalitet och omtanke kommer först.' },
        { title: 'Spara tid', desc: 'Vi underlättar vardagen så att du kan lägga din tid på det som är viktigast.' },
        { title: 'Personlig service', desc: 'Vi är ett litet företag som värnar om våra kunder och strävar efter bästa service.' },
        { title: 'Nöjd-kund-garanti', desc: 'Inte nöjd? Kontakta oss inom 24h så åtgärdar vi bristerna kostnadsfritt.' }
      ]
    },
    testimonials: {
      title: 'Vad våra kunder säger',
      subtitle: 'Vi är stolta över våra nöjda kunder'
    },
    contact: {
      title: 'Kontakta Oss',
      subtitle: 'Vi svarar gärna på dina frågor',
      name: 'Ditt namn',
      email: 'E-post',
      phone: 'Telefon',
      message: 'Meddelande',
      send: 'Skicka meddelande',
      address: 'Adress',
      callUs: 'Ring oss',
      emailUs: 'Maila oss'
    },
    faq: {
      title: 'Vanliga Frågor',
      subtitle: 'Svar på de vanligaste frågorna'
    },
    footer: {
      tagline: 'Professionell städning med den personliga touchen',
      quickLinks: 'Snabblänkar',
      contactInfo: 'Kontaktinfo',
      followUs: 'Följ oss',
      rights: '© 2025 Stockholm Elite Städ. Alla rättigheter förbehållna.',
      developedBy: 'Stolt utvecklad av',
      privacy: 'Integritetspolicy',
      cookies: 'Cookies'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About Us',
      contact: 'Contact',
      faq: 'FAQ',
      admin: 'Admin'
    },
    hero: {
      title: 'Clean, Beautiful & Affordable',
      subtitle: 'Professional cleaning with a personal touch',
      cta: 'Calculate Price',
      secondaryCta: 'Contact Us'
    },
    calculator: {
      title: 'Calculate Your Cleaning Price',
      propertyType: 'Property Type',
      size: 'Size (m²)',
      cleaningType: 'Cleaning Type',
      frequency: 'How Often?',
      addons: 'Add-on Services',
      rutDeduction: 'RUT Tax Deduction',
      rutYes: 'Yes, apply RUT',
      rutNo: 'No',
      basePrice: 'Base Price',
      discount: 'Discount',
      afterRut: 'After RUT Deduction',
      total: 'Total to Pay',
      book: 'Book Cleaning',
      pricesInclude: '* All prices include VAT and after RUT deduction. All equipment and materials included.'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Professional cleaning for homes and businesses',
      private: 'Private',
      business: 'Business & HOA',
      learnMore: 'Learn more'
    },
    about: {
      title: 'About Us',
      subtitle: 'Your satisfaction always comes first',
      whyUs: 'Why Choose Us?',
      features: [
        { title: 'A Safe Choice', desc: 'We take care of your home in the best way. Safety, quality and care come first.' },
        { title: 'Save Time', desc: 'We make everyday life easier so you can spend time on what matters most.' },
        { title: 'Personal Service', desc: 'We are a small company that cares about our customers and strives for the best service.' },
        { title: 'Satisfaction Guarantee', desc: 'Not satisfied? Contact us within 24h and we fix any issues free of charge.' }
      ]
    },
    testimonials: {
      title: 'What Our Customers Say',
      subtitle: 'We are proud of our satisfied customers'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'We are happy to answer your questions',
      name: 'Your Name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      send: 'Send Message',
      address: 'Address',
      callUs: 'Call Us',
      emailUs: 'Email Us'
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Answers to the most common questions'
    },
    footer: {
      tagline: 'Professional cleaning with a personal touch',
      quickLinks: 'Quick Links',
      contactInfo: 'Contact Info',
      followUs: 'Follow Us',
      rights: '© 2025 Stockholm Elite Städ. All rights reserved.',
      developedBy: 'Proudly developed by',
      privacy: 'Privacy Policy',
      cookies: 'Cookies'
    }
  }
};

export const images = {
  hero: 'https://images.unsplash.com/photo-1724582586413-6b69e1c94a17?w=1920&q=80',
  cleaning1: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&q=80',
  livingRoom: 'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=800&q=80',
  modernHome: 'https://images.unsplash.com/photo-1723748972084-4124765e0a55?w=800&q=80',
  dining: 'https://images.unsplash.com/photo-1611269154421-4e27233ac5c7?w=800&q=80',
  carpetCleaning: 'https://images.unsplash.com/photo-1742483359033-13315b247c74?w=800&q=80',
  officeCleaning: 'https://images.unsplash.com/photo-1627905646269-7f034dcc5738?w=800&q=80',
  officeSpace: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=800&q=80'
};
